/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Pauschalbesteuerungminijob2Inputs */



/**

* @param {_Field_Pauschalbesteuerungminijob2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_pauschalbesteuerungminijob2 = /** @type {((inputs?: _Field_Pauschalbesteuerungminijob2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Pauschalbesteuerungminijob2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Pauschalbesteuerung Mini-Job")
});
export { _field_pauschalbesteuerungminijob2 as "_field_pauschalbesteuerungMiniJob" }